<template>
  <div>
    <Plan title="修改密码" class="marginTop20" v-if="false">
      <div class="box">
        <div class="person font400">用户名</div>
        <div class="person marginTop15">Admina007</div>
        <div class="person marginTop20 font400">
          原登录密码
        </div>
        <el-input
          class="passWord width320 marginTop8 fixPass"
          placeholder="请填写原登录密码"
          v-model="input"
          show-password
        >
        </el-input>

        <div class="person marginTop20 font400">
          新登录密码
        </div>
        <el-input
          class="passWord width320 marginTop8 fixPass"
          placeholder="请填写新登录密码"
          v-model="input"
          show-password
        >
        </el-input>

        <div class="person marginTop20 font400">
          新登录密码
        </div>
        <el-input
          class="passWord width320 marginTop8 fixPass"
          placeholder="请再次填写新登录密码"
          v-model="input"
          show-password
        >
        </el-input>
        <div class="total marginTop20 delBtn">
          <el-button class="noneBorder">确认修改</el-button>
        </div>
      </div>
    </Plan>
    <Plan title="修改绑定手机" class="marginTop20">
      <div class="box">
        <div class="person font400">用户名</div>
        <div class="person marginTop15">Admina007</div>

        <div class="person marginTop20 font400">手机号</div>
        <div class="person marginTop15">180859894767</div>
        <div class="person marginTop20 font400">
          手机验证码
        </div>
        <el-input
          class="passWord width320 marginTop8 fixPass"
          placeholder="请填写手机验证码"
          v-model="input"
          show-password
        >
        </el-input>

        <div class="person marginTop20 font400">
          新手机号
        </div>
        <el-input
          class="passWord width320 marginTop8 fixPass"
          placeholder="请再次填写新登录密码"
          v-model="input"
          clearable
        >
        </el-input>
        <div class="del">发送手机验证码</div>
        <div class="total marginTop20 delBtn">
          <el-button class="noneBorder">确认修改</el-button>
        </div>
      </div>
    </Plan>
  </div>
</template>
<style lang="less" scoped>
.back {
  position: relative;
  padding-top: 40px;
  padding-left: 46px;
  padding-right: 46px;
  padding-bottom: 35px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.08);
}
.person {
  font-size: 12px;
  font-weight: 400;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}
.blueBorder {
  width: 200px;
  // height: 40px;
  border: 1px solid rgba(0, 130, 164, 1);
  opacity: 1;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0) !important;
  font-size: 16px;
  font-weight: 400;
  color: rgba(0, 130, 164, 1);
  margin-top: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.del {
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  opacity: 1;
  position: absolute;
  left: 547px;
  top: 359px;
  width: 102px;
  height: 38px;
  background: rgba(0, 177, 255, 1);
  opacity: 1;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.noneBorder {
  width: 200px;
  height: 40px;
  border: 1px solid rgba(0, 130, 164, 1);
  opacity: 1;
  border-radius: 20px;
  background: rgba(0, 130, 164, 1) !important;
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  margin-top: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.delBtn {
  text-align: left;
  align-items: center;
}
</style>

<script>
import Plan from "@/components/Plan.vue";
export default {
  components: {
    Plan
  },
  data() {
    return {
      input: ""
    };
  }
};
</script>
